/** Container width (px) from which the billing page gets a side column. */
export const BILLING_TWO_COLUMN_WIDTH = 1080;
